import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { LuIndianRupee } from "react-icons/lu";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { updateStatusForTimeline } from "../../../api/timelineService";
import { updateCompanyDetails } from "../../../api/userService";
import {
  allBusinessTypes,
  getCustomSelectTagStyles,
  indianStatesArray,
} from "../../../constants";
import useCustomToast from "../../../customHooks/useCustomToast";
import { setCompanyName } from "../../../Redux/companySlice";
import { setUserTimelineStep } from "../../../Redux/userSlice";
import {
  formatNumberWithCommas,
  isValidPanCard,
  isValidWebsite,
} from "../../../utils/UTILITY_METHODS";

const BusinessDetails = () => {
  const [businessDetails, setBusinessDetails] = useState({
    companyName: "",
    companyPan: "",
    companyWebsite: "",
    indianState: "",
  });

  const [businessRevenue, setBusinessRevenue] = useState({
    currentYearRevenue: "",
    lastYearRevenue: "",
  });

  const [businessType, setBusinessType] = useState("");

  const dispatch = useDispatch();

  const showToast = useCustomToast();

  const handleBusinessDetailsChange = (e) => {
    const { name, value } = e.target;
    setBusinessDetails((prev) => ({
      ...prev,
      [name]: name === "companyPan" ? value.toUpperCase() : value,
    }));
  };

  const handleBusinessRevenueChange = (e) => {
    const { name, value } = e.target;
    const rawValue = value.replace(/,/g, "");
    const lastChar = rawValue[rawValue.length - 1];
    // If the last character is not a digit (0-9), do nothing
    if (!/^\d$/.test(lastChar) && rawValue) {
      showToast("Please enter valid number", "error");
      return;
    }
    setBusinessRevenue((prev) => ({ ...prev, [name]: rawValue }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleKeyDown = (e, nextInputName) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputName) {
        const nextInput = document.querySelector(
          `input[name="${nextInputName}"]`
        );
        if (nextInput) {
          nextInput.focus();
        }
      } else {
        handleSubmit(e);
      }
    }
  };

  const submitData = async () => {
    try {
      if (
        !businessDetails.companyName.trim() ||
        !businessDetails.companyPan.trim() ||
        !businessDetails.companyWebsite.trim() ||
        !businessDetails.indianState.trim() ||
        !businessType.trim() ||
        !businessRevenue.currentYearRevenue.trim() ||
        !businessRevenue.lastYearRevenue.trim()
      ) {
        showToast("All Fields are required", "error");
        return;
      }

      if (!isValidPanCard(businessDetails.companyPan)) {
        showToast("Please enter valid PAN number", "error");
        return;
      }

      if (!isValidWebsite(businessDetails.companyWebsite)) {
        showToast("Please enter valid website url", "error");
        return;
      }

      const response = await updateCompanyDetails(
        businessDetails.companyName,
        businessDetails.companyPan?.toUpperCase(),
        businessDetails.companyWebsite,
        businessDetails.indianState,
        businessType,
        businessRevenue.currentYearRevenue,
        businessRevenue.lastYearRevenue
      );

      dispatch(setCompanyName(businessDetails.companyName));
      showToast(response[0].data, "success");
      dispatch(setUserTimelineStep(4));

      //update status timeline
      updateStatusForTimeline(
        3,
        "company_information",
        "company_details",
        "completed"
      );
    } catch (error) {
      showToast(error.message, "error");
    }
  };

  return (
    <Box>
      <Heading as={"h2"} fontSize={"22px"} lineHeight={"22px"}>
        Business Details
      </Heading>

      <form onSubmit={handleSubmit}>
        <HStack columnGap={12} my={4}>
          <FormControl>
            <FormLabel fontSize={"14px"} fontWeight={400} htmlFor="companyName">
              Company Name
            </FormLabel>
            <Input
              name="companyName"
              id="companyName"
              value={businessDetails.companyName}
              onChange={handleBusinessDetailsChange}
              onKeyDown={(e) => handleKeyDown(e, "companyPan")}
              placeholder="Enter company name (50 charcters)"
              focusBorderColor="teal.500"
              py={"4"}
              fontSize={"14px"}
              backgroundColor={"white"}
              height={"50px"}
              width={"288px"}
              borderRadius={"8px"}
              borderColor={"#E8E8E8"}
            />
          </FormControl>
          <FormControl>
            <FormLabel fontSize={"14px"} fontWeight={400} htmlFor="companyPan">
              Company Pan
            </FormLabel>
            <Input
              name="companyPan"
              id="companyPan"
              value={businessDetails.companyPan}
              onChange={handleBusinessDetailsChange}
              onKeyDown={(e) => handleKeyDown(e, "companyWebsite")}
              placeholder="EHDPP1229N"
              focusBorderColor="teal.500"
              py={"4"}
              className="uppercase"
              fontSize={"14px"}
              backgroundColor={"white"}
              height={"50px"}
              width={"288px"}
              borderRadius={"8px"}
              borderColor={"#E8E8E8"}
            />
          </FormControl>
        </HStack>

        <HStack columnGap={12} mb={4}>
          <FormControl>
            <FormLabel
              fontSize={"14px"}
              fontWeight={400}
              htmlFor="companyWebsite"
            >
              Comany Website
            </FormLabel>
            <Input
              name="companyWebsite"
              id="companyWebsite"
              value={businessDetails.companyWebsite}
              onChange={handleBusinessDetailsChange}
              onKeyDown={(e) => handleKeyDown(e, "indianState")}
              placeholder="www.companyname.com"
              focusBorderColor="teal.500"
              py={"4"}
              fontSize={"14px"}
              backgroundColor={"white"}
              height={"50px"}
              width={"288px"}
              borderRadius={"8px"}
              borderColor={"#E8E8E8"}
            />
          </FormControl>

          <FormControl>
            <FormLabel fontSize={"14px"} fontWeight={400} htmlFor="indianState">
              State
            </FormLabel>
            <Select
              name="indianState"
              id="indianState"
              placeholder="Eg: Karnataka"
              options={indianStatesArray}
              styles={getCustomSelectTagStyles(
                "14px",
                "2px",
                "8px",
                "50px",
                "288px"
              )}
              isSearchable
              onChange={(option) =>
                setBusinessDetails((prev) => ({
                  ...prev,
                  indianState: option.value,
                }))
              }
            />
          </FormControl>
        </HStack>
      </form>

      <Text fontSize={"14px"} fontWeight={400} mt={5}>
        Type of Business
      </Text>
      <Box
        width="full"
        boxShadow="rgba(17, 17, 26, 0.1) 0px 0px 4px;"
        paddingX={"5"}
        paddingY={"10px"}
        borderRadius={"8px"}
        backgroundColor={"white"}
        marginTop={"10px"}
      >
        <RadioGroup
          name="businessType"
          onChange={setBusinessType}
          value={businessType}
          colorScheme="teal"
        >
          <Stack rowGap={"10px"}>
            {allBusinessTypes.map((value) => (
              <Radio
                key={value + "-business-type"}
                textTransform={"capitalize"}
                value={value}
              >
                <Box
                  color={"#595657"}
                  ml={1}
                  fontSize={"14px"}
                  textTransform="capitalize"
                >
                  {value}
                </Box>
              </Radio>
            ))}
          </Stack>
        </RadioGroup>
      </Box>

      <Box display={"flex"} columnGap={"5"} mt={"2px"}>
        <FormControl my={5} width={"50%"}>
          <FormLabel
            fontSize={"14px"}
            fontWeight={400}
            htmlFor="currentYearRevenue"
          >
            Current Year Revenue
          </FormLabel>
          <InputGroup>
            <InputLeftElement
              pointerEvents="none"
              display="flex"
              alignItems="center"
              mt={"6px"}
              ml={"6px"}
            >
              <LuIndianRupee className="text-orange-400 h-4 w-4" />
            </InputLeftElement>
            <Input
              name="currentYearRevenue"
              id="currentYearRevenue"
              type="text"
              onKeyDown={(e) => handleKeyDown(e, "lastYearRevenue")}
              value={formatNumberWithCommas(businessRevenue.currentYearRevenue)}
              onChange={handleBusinessRevenueChange}
              placeholder="Enter Amount"
              focusBorderColor="teal.500"
              pl="2.7rem"
              py={2}
              fontSize={"14px"}
              backgroundColor={"white"}
              height={"50px"}
              width={"288px"}
              borderRadius={"8px"}
              borderColor={"#E8E8E8"}
            />
          </InputGroup>
        </FormControl>
        <FormControl my={5} width={"50%"}>
          <FormLabel
            fontSize={"14px"}
            fontWeight={400}
            htmlFor="lastYearRevenue"
          >
            Last Year Revenue
          </FormLabel>
          <InputGroup>
            <InputLeftElement
              pointerEvents="none"
              display="flex"
              alignItems="center"
              mt={"6px"}
              ml={"6px"}
            >
              <LuIndianRupee className="text-orange-400 h-4 w-4" />
            </InputLeftElement>
            <Input
              name="lastYearRevenue"
              id="lastYearRevenue"
              type="text"
              value={formatNumberWithCommas(businessRevenue.lastYearRevenue)}
              onChange={handleBusinessRevenueChange}
              placeholder="Enter Amount"
              focusBorderColor="teal.500"
              pl="2.7rem"
              py={2}
              fontSize={"14px"}
              backgroundColor={"white"}
              height={"50px"}
              width={"288px"}
              borderRadius={"8px"}
              borderColor={"#E8E8E8"}
            />
          </InputGroup>
        </FormControl>
      </Box>

      <Box display={"flex"} justifyContent={"flex-start"} columnGap={4} mt={1}>
        <Button
          colorScheme="blackAlpha"
          color={"blackAlpha.700"}
          backgroundColor={"white"}
          size="sm"
          variant="outline"
          width="7.5rem"
          px={8}
          onClick={() => dispatch(setUserTimelineStep(2))}
          _hover={{ backgroundColor: "#eee" }}
        >
          Back
        </Button>
        <Button
          colorScheme="teal"
          size="sm"
          variant="solid"
          px={8}
          onClick={submitData}
          width="7.5rem"
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default BusinessDetails;
